import { selfAxios, initSelfAxios } from "@oppein/op-utils";
import {
  AppCode,
  SubAppCode,
  axiosErrorInterceptors,
  getLanguage,
  getOauth2AccessToken,
} from "./factory";
import responseHandleNewsso from "./response-handle-newsso";
import { getEnvMode } from "@/util/getEnvMode";

initSelfAxios({
  envMode: getEnvMode(),
  axiosDefaults: {
    headers: {
      common: {
        "Oauth2-AccessToken": getOauth2AccessToken(),
        "OPPEIN-Accept-Language": getLanguage(),
        AppCode: AppCode,
        SubAppCode: SubAppCode,
      },
    },
  },
});
selfAxios.interceptors.response.use(...responseHandleNewsso);
selfAxios.interceptors.response.use(...axiosErrorInterceptors);



// WEBPACK FOOTER //
// ./src/api/init-op-utils-self-axios.js